import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function TrustIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path fill="currentColor" d="M10.233 6.52a.914.914 0 0 1-1.781-.29c0-.324.167-.609.42-.772A2.7 2.7 0 0 0 8 5.31 2.68 2.68 0 0 0 5.325 8 2.68 2.68 0 0 0 8 10.688 2.68 2.68 0 0 0 10.675 8c0-.548-.163-1.056-.442-1.48" /><path fill="currentColor" d="M13.967 13.52 12.89 11.4A6 6 0 0 0 13.941 8c0-3.313-2.698-6.013-5.994-6C4.667 2.013 2.01 4.684 2 7.98 1.99 11.292 4.675 14 7.97 14a5.9 5.9 0 0 0 3.39-1.06l2.226.985c.253.112.506-.157.38-.405zM7.97 12.025c-2.212 0-4.005-1.802-4.005-4.025S5.76 3.975 7.97 3.975c2.212 0 4.006 1.802 4.006 4.025s-1.794 4.025-4.006 4.025" /></svg>
  );
}

export default TrustIcon;
